<template>
  <TrfSelect
    :options="templatesAsOptions"
    :noOptionsText="'Fluxo(s) não encontrado(s)'"
    label="Qual será o fluxo neste processo?"
    idSelect="processo-form-legalizacao-fluxo"
    @valueSelect="$event => setTemplateId($event)"
    placeholder="Selecione"
    ref="campoLegalizacaoFluxo"
    :loadingData="loadingTemplates"
    :disabled="loadingTemplates || disabledFluxo"
    :mensagemCampoObrigatorio="'O fluxo do processo é obrigatório.'"
  >
    <template #erroMessage>
      <span class="campo-obrigatório">O fluxo do processo é obrigatório.</span>
    </template>
  </TrfSelect>
  <TrfDateInput
    :isDiaMesEAno="true"
    :permitirAnterior="false"
    label="Qual a expectativa de conclusão do processo?"
    placeholder="DD/MM/AAAA"
    id="processo-form-legalizacao-previsao-conclusao"
    maxlength="10"
    v-model="formData.dataPrevisaoConclusao"
    ref="campoLegalizacaoPrevisaoConclusao"
    :mensagemCampoObrigatorio="'Informe uma data para prosseguir.'"
    :disabled="disabledDataConclusao"
  ></TrfDateInput>
  <TrfInput
    :label="`Nome do ${processoNameplate}`"
    :placeholder="`Nome do ${processoNameplate}`"
    id="processo-form-legalizacao-nome"
    v-model="formData.nomeNegocio"
    maxLength="50"
    ref="campoLegalizacaoNome"
  ></TrfInput>
  <TrfToolbarTextEditor
    :label="`Detalhes sobre o ${processoNameplate}`"
    id="campo-detalhes-negocio"
    @changeText="doChangeDetalheNegocio"
    @ready="($event) => setLoading('detalheNegocio', $event)"
    :isObrigatorio="false"
    :maxlength="detalheNegocio.maxLength"
    :tipLabel="tipLabelDetalheNegocio"
    ref="campoLegalizacaoDetalheNegocio"
  ></TrfToolbarTextEditor>
</template>
<script>
import { defineAsyncComponent } from 'vue';

export default {
  name: 'TrfProcessosFormularioBase',
  expose: ['inicializarCampos', 'doReset', 'marcarValidacoes', 'validacoes'],
  components: {
    TrfInput: defineAsyncComponent(() => import('../../../../components/Input/index.vue')),
    TrfSelect: defineAsyncComponent(() => import('../../../../components/Select/index.vue')),
    TrfToolbarTextEditor: defineAsyncComponent(() => import('../../../../components/ToolbarTextEditor/index.vue')),
    TrfDateInput: defineAsyncComponent(() => import('../../../../components/Input/TrfDateInput.vue'))
  },
  props: {
    templates: {
      type: Array,
      default: new Array()
    },
    loadingTemplates: {
      type: Boolean,
      default: true
    },
    isProcessoComEmpresaExistente: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        templateId: '',
        dataPrevisaoConclusao: '',
        nomeNegocio: '',
        detalheNegocio: ''
      },
      loadings: {
        templates: true,
        detalheNegocio: true
      },
      disabledDataConclusao: false,
      disabledFluxo: false,
      detalheNegocio: {
        maxLength: 5000,
        plainText: ''
      }
    };
  },
  computed: {
    processoNameplate() {
      return this.isProcessoComEmpresaExistente ? 'processo' : 'negócio';
    },
    tipLabelDetalheNegocio() {
      let count = this.detalheNegocio.maxLength;
      if(this.formData.detalheNegocio) {
        count -= this.detalheNegocio.plainText.length;
      }

      return `Adicione informações complementares ao ${this.processoNameplate}, caso necessário - ${count} caracteres restantes.`;
    },
    templatesAsOptions() {
      if (!Array.isArray(this.templates)) return []
      const optionList = [];
      for (const template in this.templates) {
        const option = {
          label: this.templates[template].nome,
          value: this.templates[template].id
        }
        optionList.push(option)
      }
      return optionList
    },
    validacoes() {
      const isTemplateIdValido = this.disabledFluxo ? true : !!this.formData.templateId;
      const isDataPrevisaoConclusaoValida = this.isDataPrevisaoConclusaoValida(this.formData.dataPrevisaoConclusao);
      const isNomeNegocioValido = !!this.formData.nomeNegocio;
      const isFormValido = isTemplateIdValido && isDataPrevisaoConclusaoValida && isNomeNegocioValido;
      const validacoes = {
        form: isFormValido,
        campos: {
          templateId: isTemplateIdValido,
          dataPrevisaoConclusao: isDataPrevisaoConclusaoValida,
          nomeNegocio: isNomeNegocioValido
        }
      };
      return validacoes;
    }
  },
  watch: {
    formData: {
      immediate: true,
      handler() {
        this.$emit('update:form-data', this.formData)
      },
      deep: true
    },
  },
  methods: {
    setTemplateId(valor) {
      this.formData.templateId = valor;
    },
    setDataPrevisaoConclusao(valor) {
      if (this.isDataPrevisaoConclusaoValida(valor)) {
        this.formData.dataPrevisaoConclusao = new Date(valor);
        return;
      }
      this.formData.dataPrevisaoConclusao = '';
    },
    setNomeNegocio(valor) {
      this.formData.nomeNegocio = valor;
    },
    doChangeDetalheNegocio(value) {
      const plainText = this.$refs.campoLegalizacaoDetalheNegocio.getValueAsText();
      if(plainText.length > this.detalheNegocio.maxLength) {
        return;
      }

      this.setDetalheNegocio(value);
      this.detalheNegocio.plainText = plainText;
    },
    setDetalheNegocio(valor) {
      this.formData.detalheNegocio = valor;
    },
    setLoading(chave, valor) {
      if (!chave || !this.loadings[chave] || !valor) return;
      this.loadings[chave] = valor;
    },
    isDataPrevisaoConclusaoValida(valor) {
      const resultado = !this.$refs.campoLegalizacaoPrevisaoConclusao.verificarSeInputEstaVazio(true); //Validacao
      return resultado;
    },
    doReset() {
      this.$refs.campoLegalizacaoFluxo.limparSelect();
      this.$refs.campoLegalizacaoFluxo.limparValue();
      this.$refs.campoLegalizacaoFluxo.limparValidacao();
      this.$refs.campoLegalizacaoPrevisaoConclusao.limparInput();
      this.$refs.campoLegalizacaoPrevisaoConclusao.limparValidacao();
      this.$refs.campoLegalizacaoNome.limparInput();
      this.$refs.campoLegalizacaoNome.limparValidacao();
      this.$refs.campoLegalizacaoDetalheNegocio.limparCampo();
      this.formData = {
        templateId: '',
        dataPrevisaoConclusao: '',
        nomeNegocio: '',
        detalheNegocio: ''
      };
      this.disabledDataConclusao = false;
      this.disabledFluxo = false;
    },
    marcarValidacoes() {
      if (!this.validacoes.campos.templateId) {
        this.$refs.campoLegalizacaoFluxo.verificarSeInputEstaVazio()
      }
      if (!this.validacoes.campos.campoLegalizacaoPrevisaoConclusao) {
        this.$refs.campoLegalizacaoPrevisaoConclusao.verificarSeInputEstaVazio()
      }
      if (!this.validacoes.campos.nomeNegocio) {
        this.$refs.campoLegalizacaoNome.verificarSeInputEstaVazio()
      }
    },
    inicializarCampos(dados) {
      const dateArray = dados.dataPrevisaoConclusao.split('-');
      this.formData.dataPrevisaoConclusao = `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`;
      this.setTemplateId(dados.templateId);
      this.setNomeNegocio(dados.nomeNegocio);
      this.setDetalheNegocio(dados.detalheNegocio);
      this.$refs.campoLegalizacaoDetalheNegocio.iniciarTextEditorComValor(dados.detalheNegocio);
      if(dados.templateId) {
        this.$refs.campoLegalizacaoFluxo.iniciarSelectComValor(dados.templateId);
      }
      this.disabledDataConclusao = true;
      this.disabledFluxo = dados.isAlgumaFaseConcluida || dados.isAlgumaFaseParalisada;
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.multiselect-econtador {
  margin: 0;
}
</style>
